import Component from '@glimmer/component';
import { service } from '@ember/service';
import { date, formatTime, formatElapsedTime } from '../time.js';

export default class DateTimeElapsedComponent extends Component {
  @service time;

  <template>
    {{#if @value}}
      <span class="text-nowrap">
        {{formatTime (date @value)}}
      </span>
      <span class="text-nowrap">
        ({{formatElapsedTime (date @value) this.time.now}})
      </span>
    {{/if}}
  </template>
}
